// extracted by mini-css-extract-plugin
export default {"titleAndAuthor":"Post_titleAndAuthor__atP0-","content":"Post_content__qw4+i","link":"Post_link__xxqWl"};